var exports = {
  "TQ": "Checkbox.module__checkboxWrapper___THJ4SE",
  "r9": "Checkbox.module__disabled___THJ4SE",
  "iD": "Checkbox.module__menuDisabled___THJ4SE",
  "kv": "Checkbox.module__checkbox___THJ4SE",
  "aP": "Checkbox.module__box___THJ4SE",
  "LI": "Checkbox.module__round___THJ4SE",
  "KD": "Checkbox.module__checked___THJ4SE",
  "NX": "Checkbox.module__checkedInverted___THJ4SE",
  "e_": "Checkbox.module__inverted___THJ4SE",
  "oE": "Checkbox.module__checkIcon___THJ4SE",
  "HN": "Checkbox.module__invertedIcon___THJ4SE",
  "Pf": "Checkbox.module__label___THJ4SE",
  "hJ": "Checkbox.module__labelInteractive___THJ4SE",
  "QK": "Checkbox.module__labelText___THJ4SE",
  "GR": "Checkbox.module__keyboardShortcut___THJ4SE",
  "RA": "Checkbox.module__keyboardShortcutKey___THJ4SE",
  "wf": "Checkbox.module__keyboardShortcutLabel___THJ4SE",
  "xB": "Checkbox.module__keyboardShortcutHint___THJ4SE",
  "wP": "Checkbox.module__keyboardShortcutPortal___THJ4SE",
  "nV": "Checkbox.module__labelFocusRing___THJ4SE",
  "P8": "Checkbox.module__menuChecked___THJ4SE",
  "fb": "Checkbox.module__checkboxIndicator___THJ4SE",
};

module.exports = exports;
